(function($) {
    $(document).ready(function(){
        function translate(text) {

            var expressions = {
                'th([nsl,.]|\\s|$)'		: 'τη$1',
                'th'          		: 'θ',
                's([,.]|\\s|$)'            	: 'ς$1',
                'ps'                     	: 'ψ',
                'ks'                     	: 'ξ'
            }
            var GR = 'avbgdezh8iklmnoprstuyfxwAVBGDEZHIKLMNOPRSTUYFXW,'
            var ENG  = 'αββγδεζηθικλμνοπρστυυφχωΑΒΒΓΔΕΖΗΙΚΛΜΝΟΠΡΣΤΥΥΦΧΩ,'

            for (var i = 0; i < ENG.length; i++) {
                if (!expressions[ENG.charAt(i)]) {
                    expressions[ENG.charAt(i)] = GR.charAt(i)
                }
            }
            for (var expression in expressions) {
                text = text.replace(new RegExp(expression, 'g'), expressions[expression])
            }
            return text.replace(/\s+/g, '-').toLowerCase();
        }

        $('.menu-trigger').on('click',function(e){
            if ($(this).hasClass('open')) {
                console.log("is open");
            }else {
                $('.main-menu > li').removeClass('active').removeClass('hidden');
                console.log("remove active");
            }
        });

        // trigger intercom
        $( "#error_page-content .live, #ngo, #startup" ).click(function(e) {
            e.preventDefault();
            Intercom('showMessages');
        });

        $('#register-form #sitename').attr('readonly', true);
        $(document).on('change keyup keydown input','#register-form #company',function(){
            $('#register-form #sitename').val(translate($(this).val()));
        });
    });
})(jQuery);
